import styled from '@emotion/styled';
import { useRouter } from 'next/router';

// components
import CategoryList from './CategoryList';
import TabbarBox from './TabbarBox';

// constants
import { useTranslation } from 'next-i18next';
import { useGetProductType, useGetStandardCode } from '@hooks/fetch/useProductFetch';
import Tabbar from '@components/_atoms/Tabbar';
import { TabbarVariant } from '@constants/atoms';
import { useState } from 'react';
import { useRecoilState } from 'recoil';
import { standardCodeState } from '@recoil/standard';
import { useGetStandardCodeCookie } from '@utils/standardCode';
import { setCookie } from '@utils/cookie';
import { DAY } from '@constants/time';

const Layout = styled.div``;

const CodeTabbarWrapper = styled.div`
  display: flex;
  justify-content: left;
  margin-bottom: 16px;
`;

export default function SearchContent() {
  const router = useRouter();

  // 다국어 지원
  const { i18n, t } = useTranslation('component');
  const ko = i18n.language === 'ko';

  const { getProductTypeFetchData } = useGetProductType();

  const [firstProductType] = getProductTypeFetchData || [];
  const defaultProductTypeId = firstProductType?.id;

  const { product_type = defaultProductTypeId } = router.query as { product_type: string };
  const productTypeIdNumber = Number(product_type);
  const selectedProductTypeName = getProductTypeFetchData?.find(
    (item) => item.id === productTypeIdNumber,
  )?.exposed_product_type;

  const standardCodeCookie = useGetStandardCodeCookie();

  const [standardCode, setStandardCode] = useRecoilState(standardCodeState)
  const handleClickTabbar = (e: React.MouseEvent<HTMLButtonElement>) => {
    const { value } = e.target as HTMLButtonElement;
    setSelectedStandardCode(value);

    const currentDomain = window.location.hostname;  
    setCookie('StandardCode', value, { maxAge: 30 * DAY, domain: currentDomain, path: '/' });
    setStandardCode(value)
  };

  const { getStandardCodeFetchData: standardCodeList, isCustomLoading: standardCodeListLoading } = useGetStandardCode();

  const [selectedStandardCode, setSelectedStandardCode] = useState(standardCodeCookie || '');

  if (productTypeIdNumber) {
    return (
      <Layout>
        {/* TabbarBox */}
        <TabbarBox product_type_id={productTypeIdNumber} />
        {/* TabbarBox end */}
        {standardCodeList && (
          <CodeTabbarWrapper>
            <Tabbar
              variant={TabbarVariant.DIVIDER}
              label={standardCodeList?.map((item: { code: string }) => item.code)}
              selectLabel={selectedStandardCode || ''}
              onClick={handleClickTabbar}
            />
          </CodeTabbarWrapper>
        )}

        {standardCodeList && (
          <CategoryList
            product_type_id={productTypeIdNumber}
            standardCodeId={standardCodeList.find((item: { code: string }) => item.code === selectedStandardCode)?.id!}
            standardCode={selectedStandardCode}
          />
        )}
      </Layout>
    );
  }
  return <></>;
}
